import styles from "./../ProductCatalog.styles";

const CatalogTabs = ({ value, onChange }) => {
    return (
        <div className="pc-tabs">
            <button
                type="button"
                className={`pc-tab ${value === "catalog" ? "active" : ""}`}
                onClick={() => onChange("catalog")}
            >
                По категориям
            </button>

            <button
                type="button"
                className={`pc-tab ${value === "all" ? "active" : ""}`}
                onClick={() => onChange("all")}
            >
                По товарам
            </button>

            <button
                type="button"
                className={`pc-tab ${value === "production" ? "active" : ""}`}
                onClick={() => onChange("production")}
            >
                По производствам
            </button>
        </div>
    );
};

export default CatalogTabs;